<template>
  <v-card color="basil" flat>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <th width="40%">Collaborator</th>
              <td class="py-3">
                <div v-for="item in fields.proposal_collaborator" :key="item.id">
                  {{item.name}} / {{ item.affiliation }} ({{ item.email }})<br>
                </div>
              </td>
            </tr>
            <tr v-if="user_type == 'proposer'">
              <th>
                Attached PDF File 
              </th>
              <td>
                <a :href="`/api/proposals/download_proposal/${fields.id}`" v-if="fields.file">{{fields.file.original_file_name}}</a></td>
            </tr>
            <tr>
              <th>Title</th>
              <td>{{fields.id}}: {{fields.title}}</td>
            </tr>
            <tr>
              <th>Abstract</th>
              <td class="nl2br">{{fields.abstract}}</td>
            </tr>
            <tr>
              <th>Keywords</th>
              <td>
                <span v-for="item in fields.selected_keywords" :key="item.id">
                  {{item.keyword_other}}<br>
                </span>
              </td>
            </tr>
            <tr>
              <th>Analysis Method</th>
              <td>
                <span v-for="item in fields.selected_methods" :key="item.id">
                  {{item.analysis_method_other}}<br>
                </span>
              </td>
            </tr>
            <tr v-if="fields.properties">
              <th>Remarks</th>
              <td class="nl2br">{{fields.properties}}</td>
            </tr>
            <tr class="no-hover">
                <th colspan="2">
                  Rationale for Requested Sample Amount
                </th>
              </tr>
              <tr>
                <th class="indent">a.  Justification for the requested sample amount</th>
                <td class="nl2br">{{ fields.sample_description_1_1 }}</td>
              </tr>
              <tr>
                <th class="indent">b.  The minimum sample amount required per measurement</th>
                <td class="nl2br">{{ fields.sample_description_1_2 }}</td>
              </tr>
              <tr class="no-hover">
                <th colspan="2">
                  Sample Allocation Flexibility (Descoping & Sharing Options)
                </th>
              </tr>
              <tr>
                <th class="indent">a.  Alternative analytical approach in case of reduced sample allocation</th>
                <td class="nl2br">{{ fields.sample_description_2_1 }}</td>
              </tr>
              <tr>
                <th class="indent">b.  Possibility of sharing the sample with other researchers</th>
                <td class="nl2br">{{ fields.sample_description_2_2 }}</td>
              </tr>
              <tr>
                <th class="indent">c.  Additional comments on sample allocation flexibility</th>
                <td class="nl2br">{{ fields.sample_description_2_3 }}</td>
              </tr>
              <tr>
                <th>Additional details or special considerations regarding the sample request</th>
                <td class="nl2br">{{ fields.sample_description_3_1 }}</td>
              </tr>
            <tr>
              <th>Effects on samples after the analysis</th>
              <td class="nl2br">{{fields.post_analysis_alternation}}</td>
            </tr>
            <tr>
              <th>Handling Facility/Tools</th>
              <td class="nl2br">{{fields.methods_to_handle_of_sample}}</td>
            </tr>
            <tr>
              <th>
                Transfer protocol of samples
              </th>
              <td>
                {{fields.environmental_condition_other}}
              </td>
            </tr>
            <tr v-if="canViewAdditionalInfo">
              <th>Terms&amp;Conditions</th>
              <td>
                <a
                  v-if="termsAndConditionsFile"
                  :href="termsAndConditionsDownloadUrl"
                >
                  {{ termsAndConditionsFile.original_file_name }}
                </a>
              </td>
            </tr>
            <tr v-if="canViewAdditionalInfo">
              <th>Shipping Information</th>
              <td>
                <div
                  v-for="(item, index) in shippingInformationList"
                  :key="item.id || index"
                >
                  {{ shippingInformationLine(item) }}
                  <v-divider
                    v-if="index !== shippingInformationList.length - 1"
                    class="my-2"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="text-center my-6" v-if="user_type != 'proposer'">
        <v-btn class="font-weight-bold mr-4" color="green darken-4" large dark
          :href="`/api/proposals/download_proposals/${fields.id}`"
        >
          PDF Export
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'tabDetail',
  props: ['fields', 'user_type'],
  data() {
    return {
      shippingContainerTypeMap: {},
      shippingCommercialDeliveryMap: {},
    };
  },
  computed: {
    canViewAdditionalInfo() {
      return this.user_type === 'proposer' || this.user_type === 'admin';
    },
    termsAndConditionsFile() {
      const files = Array.isArray(this.fields.files) ? this.fields.files : [];
      return files.find((file) => Number(file.type) === 4) || null;
    },
    termsAndConditionsDownloadUrl() {
      if (this.user_type === 'admin') {
        return `/api/proposals/admin/download_proposal/${this.fields.id}?type=4`;
      }
      return `/api/proposals/download_proposal/${this.fields.id}?type=4`;
    },
    shippingInformationList() {
      return Array.isArray(this.fields.shipping_information) ? this.fields.shipping_information : [];
    },
  },
  mounted() {
    this.$axios.get('/api/masters/shipping_container_type').then((response) => {
      this.shippingContainerTypeMap = response.data.reduce((acc, item) => {
        acc[item.id] = item.label;
        return acc;
      }, {});
    });
    this.$axios.get('/api/masters/commercial_delivery_type').then((response) => {
      this.shippingCommercialDeliveryMap = response.data.reduce((acc, item) => {
        acc[item.id] = item.label;
        return acc;
      }, {});
    });
  },
  methods: {
    shippingContainerTypeLabel(value) {
      return this.shippingContainerTypeMap[Number(value)] || '';
    },
    shippingCommercialDeliveryLabel(value) {
      return this.shippingCommercialDeliveryMap[Number(value)] || '';
    },
    shippingInformationLine(item) {
      const row = item || {};
      return `Recipient Organization: ${row.organization || ''} / Shipping Address: ${row.address || ''} / Responsible Person for Sample Reception: ${row.contact_person || ''} / Organization's Official Representative: ${row.representative || ''} / Affiliated Institute: ${row.affiliated_institute || ''} / Primary Business Field: ${row.primary_business_field || ''} / Official Website: ${row.official_website || ''} / Sample Container Type: ${this.shippingContainerTypeLabel(row.container_type)} / Additional Description (if Other): ${row.container_description || ''} / Commercial Delivery: ${this.shippingCommercialDeliveryLabel(row.commercial_delivery)}`;
    },
  },
};
</script>
<style>
.indent {
  padding-left: 2em;
}

.no-hover {
    background-color: inherit;
}
</style>
